import { IsNotEmpty, IsArray, IsString, MinLength, MaxLength } from 'class-validator';

export class CalendarEventDeployPendingDTO {

    @IsNotEmpty()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    events: Array<string>;

}
